import { Component } from '@angular/core';
import { OktaCallbackComponent } from '@okta/okta-angular';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

@Component({
  templateUrl: './callback-component.html',
  standalone: true,
  imports: [ProgressSpinnerModule]
  
})
export class CallbackComponent extends OktaCallbackComponent {
}